import { css } from '@emotion/react';

const makePostSubmissionQuestionsStyles = ({ theme }) => {
  const { palette } = theme.mvf;

  return {
    container: css({
      display: 'flex',
      flexDirection: 'column',
    }),
    backButton: css({ textAlign: 'left' }),
    backLink: css({
      textTransform: 'none',
      padding: 0,
      color: palette.component.answerSelectedColor,
      fontWeight: theme.mvf.typography.weight.medium,
    }),
    solarBackLink: css({
      color: palette.component.continueButtonColor,
    }),
    question: css({
      marginTop: 16,
    }),
    progress: css({
      fontSize: '0.75rem',
      letterSpacing: '0.02em',
      color: palette.text.secondaryTextColor,
      marginBottom: 4,
    }),
    continueButton: css({
      marginTop: 24,
    }),
  };
};

export default makePostSubmissionQuestionsStyles;
